import React from "react";
import themeLarge from "../ThemeLarge";
import ProjectProfile from "./ProjectProfile";
import ProjectSortView from "./ProjectSort";
import ProjectSortYearMobile from "./mobile/ProjectSortYearMobile";


class ProjectView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: "All",
      totalProjects: 0,
    };
  }

  handleFilterChange = (label) => {
    this.setState({ filter: label });
  };

  filterProjects = () => {
    const { allProjects } = this.props;
    const { filter } = this.state;

    if (!allProjects) return [];

    const now = new Date();
    const currentYear = now.getFullYear();
    const todaySortable = `${currentYear}${String(now.getMonth() + 1).padStart(
      2,
      "0"
    )}`;

    let filtered = allProjects;

    if (filter !== "All") {
      filtered = allProjects.filter((project) => {
        const period = project.period || {};
        const fromYear = parseInt(period.from?.slice(2), 10);
        const toYear = parseInt(period.to?.slice(2), 10);

        if (!fromYear && !toYear) return false;

        if (filter === "Older") {
          return fromYear < currentYear - 2 && toYear < currentYear - 2;
        }

        const targetYear = parseInt(filter, 10);
        return fromYear === targetYear || toYear === targetYear;
      });
    }

    // Sort by end date desc; no 'to' = treat as today for sorting
    const toSortable = (to) => {
      if (to && to.length === 6) {
        const mm = to.slice(0, 2);
        const yyyy = to.slice(2);
        return `${yyyy}${mm}`; // e.g., "032025" -> "202503"
      }
      // No end date -> ongoing -> sort as today
      return todaySortable;
    };

    filtered.sort((a, b) => {
      const sortableA = toSortable(a.period?.to);
      const sortableB = toSortable(b.period?.to);
      return sortableB.localeCompare(sortableA); // newer (including ongoing) first
    });

    return filtered;
  };

  render() {
    const { isMobile } = this.props;
    const filteredProjects = this.filterProjects();
    return (
      <div
        style={{
          background: themeLarge.colors.bg,
          paddingTop: "20px",
          paddingLeft: isMobile ? "35px" : "100px",
          paddingRight: isMobile ? "35px" : "100px",
          paddingBottom: "20px",
        }}
      >
        {!isMobile && (
          <div className="row">
            <p
              className="d-flex justify-content-center"
              style={{
                fontFamily: "Kumbh Sans",
                fontSize: themeLarge.fontSize.h1,
                color: themeLarge.colors.text,
              }}
            >
              Projects
            </p>
          </div>
        )}

        {/* sort Desktop*/}
        {!isMobile && (
          <>
            <ProjectSortView onFilterChange={this.handleFilterChange} />
          </>
        )}
        {/* sort Mobile */}
        {isMobile && (
          <>
            <ProjectSortYearMobile onFilterChange={this.handleFilterChange} />
          </>
        )}
        {/* <ProjectCountShow /> */}

        {/* loop through allProjects */}
        {filteredProjects.map((project) => (
          <div
            key={project.id}
            id={`project-${project.id}`}
            style={{ marginBottom: isMobile ? "20px" : "40px" }}
          >
            <ProjectProfile latestProject={project} isMobile={isMobile} />
          </div>
        ))}
      </div>
    );
  }
}

export default ProjectView;
